<div class=" external-supplier-page-container">
    <div class="image-banner">
        <img alt="logo" src="../../img/project-estimator-logo.svg" class=" new-logo">
    </div>

    <div class="main-container">
        <modal v-if="state === 'LOADING' || state === 'ERROR'" :height="'140px'" :width="'400px'" :alignMiddle="true"
               hide-close>
            <div style="display: flex;flex-direction: column; align-items: center">
                <h3 slot="header" style="text-align: center; padding-top: 10px">
                    <fa v-if="state !== 'ERROR'" icon="circle-notch" spin></fa>
                    {{ message }}
                </h3>
                <button v-if="state !== 'ERROR'" @click="reloadPage()" style="width: 30%; margin-top: 5px"
                        class="btn btn-primary custom-btn">Reload Page
                </button>
            </div>
            <div slot="footer"></div>
        </modal>

        <modal v-if="cannotQuoteActive" :height="'300px'" :width="'250px'" :alignMiddle="true" hideClose>
            <header>
                <fa :icon="['fal', 'times']"
                    class="closeIcon pull-right float-right is-pulled-right" size="lg" title="Close"
                    @click="close"></fa>
            </header>
            <label for="reasons">
                Please Select The Reason:
            </label>
            <div id="reasons" style="margin-top: 1.5em">
                <ul class="list-group">
                    <li v-for="(availableReason) in reasons" class="list-group-item"
                        :class="{active: availableReason === reason}" @click="setReason(availableReason)">
                        {{ availableReason }}
                    </li>
                </ul>
            </div>
            <footer>
                <button v-if="reason !== null" class="btn btn-block custom-btn" style="height: 90%; margin-top: 3em"
                        @click="cannotQuote">
                    Submit
                </button>
            </footer>
        </modal>
        <div class="nav-bar">
            <ul class='nav nav-wizard'>
                <li
                        v-for="(step, index) in steps"
                        class="item"
                        :class="{ active: index === currentIndex }"
                        @click="navigate(step.path)"
                >
                    <router-link :to="step.path" @click.native.prevent>
                        <span>{{ step.label }}</span>
                    </router-link>
                </li>
            </ul>
        </div>
        <div v-if="isSupplierView && externalQuote.state.state === 'CANNOT_QUOTE'" class="quote-checker">
            <h2>Quote marked as Not Possible To Quote!!!</h2>
            <button style="width: 50%" class="quote-project-button"
                    button @click="reQuoteProject"
                    type="button"
                    :title="'Remove Uploaded Files'" v-tooltip>
                <span>Can Quote Project</span>
            </button>
        </div>
        <div>
            <div v-if="currentStep === 'projectDetails'">
                <div class="project-details-container ">
                    <fieldset class="project-container">
                        <div class="overview-label-header">
                            <label for="externalQuoteDetails" class="section-title-label">Project</label>
                        </div>
                        <div id="yourQuoteDetails" class="overview-details">
                            <ul>
                                <li>Project Postcode:
                                    <span v-if="partialPostcode !== null" class="detail">{{ partialPostcode }}*</span>
                                    <span v-else class="detail">Not Available</span>
                                </li>
                                <li>Brand: <span class="detail">{{ brand }}</span></li>
                                <li>Branch: <span class="detail">{{ branch }}</span></li>
                            </ul>
                            <ul>
                                <li>Project Reference: <span class="detail">{{ ref }}</span></li>
                                <li>Executive Customer: <span class="detail">{{ isExecutive }}</span></li>
                            </ul>
                        </div>
                    </fieldset>
                    <div class="plans-section-project-Details cards">
                        <div class="overview-label-header">
                            <label for="externalQuoteDetails" class="section-title-label">Plans</label>
                        </div>
                        <div class="plans-display-section">
                            <div v-if="state === 'READY' && plans" class="panel-body-override">
                                <div v-for="(file, index) in plansPrepared" class=" canDownload" :title="file.name"
                                     v-tooltip>
                                    <a target="_blank" :href="downloadLink(file, 'plan')"
                                       @click="recordDownloadClick(file, 'plan')">
                                        <div class="individual-plan-icon">
                                            <fa :icon=" file.icon"></fa>
                                        </div>
                                        <div class="individual-plan-text">
                                            <div>
                                                <span class="plan-text">Plan {{ index + 1 }}</span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div v-else>This project has no uploaded plans</div>
                        </div>
                    </div>
                    <div v-if="plansZip.message" class="plans-zip-notice">
                        {{ plansZip.message }}
                    </div>
                    <button v-if="isExternalQuoteActive && !isPlansZipReady"
                            class="download-plans-button"
                            @click="downloadAllPlans"
                            type="button"
                            :disabled="isPlansZipBusy"
                            :title="'Download plans'" v-tooltip>
                        {{ plansZipButtonLabel }} &nbsp;&nbsp;<fa icon="cloud-arrow-down"></fa>
                    </button>
                    <a v-if="isExternalQuoteActive && isPlansZipReady"
                       :href="allPlansLink()"
                       class="download-plans-button"
                       @click="downloadPreparedPlansZip"
                       :title="'Download prepared plans ZIP'" v-tooltip>
                        {{ plansZipButtonLabel }} &nbsp;&nbsp;<fa icon="cloud-arrow-down"></fa>
                    </a>
                </div>
            </div>

            <div v-if="currentStep === 'submission'">
                <div class="details-container">
                    <div class="left-side">
                        <fieldset class="fieldset-upload-quotes card">
                            <div class="overview-label-header">
                                <label for="externalQuoteDetails" class="section-title-label">Upload Quotes</label>
                            </div>
                            <div id="quotesUpload" class="upload-button-override">
                                <b-upload v-model="filesToUpload"
                                          v-if="!filesToUpload.length"
                                          multiple
                                          class="upload-section"
                                          drag-drop>
                                    <section class="section">
                                        <div class="content has-text-centered">
                                            <p>
                                                <b-icon
                                                        icon="upload"
                                                        size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Drop your files here or click to upload</p>
                                        </div>
                                    </section>
                                </b-upload>
                                <div v-if="filesToUpload.length" class="file-list">
                                    <h4 class="Uploaded-Files-label">Uploaded Files:</h4>
                                    <ul>
                                        <li v-for="(file, index) in filesToUpload" :key="index"
                                            class="uploaded-files-item">
                                            <span class="upload-file-label"> {{ file.name }} </span>
                                            <button @click="deleteDropFile(index)" class="delete-file-button">X</button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </fieldset>
                        <div class="displayAsColumn  user-actions card">
                            <div class="overview-label-header">
                                <label for="externalQuoteDetails" class="section-title-label">Action Details</label>
                            </div>
                            <div class="user-actions-section">
                                <div class="displayAsRow top-displayAsRow">
                                    <label for="externalQuoteReference" class="action">Enter reference number:</label>
                                    <input id="externalQuoteReference" type="text" class="input-override" maxlength="16"
                                           v-model="externalReference">
                                </div>
                                <div class="displayAsRow">
                                    <label for="cost" class="action">Enter cost:</label>
                                    <input id="cost" type="number" class="input-override" maxlength="16"
                                           v-model="cost">
                                </div>
                                <div class="displayAsRow">
                                    <label for="leadTime" class="action">Enter lead time:</label>
                                    <select id="leadTime" class=" dropdown-override" v-model="leadTime">
                                        <option v-for="leadTimeOption in leadTimeOptions" class="dropdown-item">
                                            {{ leadTimeOption }}
                                        </option>
                                    </select>
                                </div>
                                <h6 class="text-danger fine-print">
                                    **Please note that all the above fields are required**
                                </h6>
                            </div>
                        </div>
                        <div class="half-spacing" style="margin-bottom: 0">
                            <h4 class="text-danger">
                                If more information is required to quote accurately, please contact the Branch for
                                further
                                info – Contact details can be found on the Overview page
                            </h4>
                        </div>
                    </div>
                    <div class="additional-notes-container">
                        <fieldset class="fieldset-notes-section">
                            <div class="overview-label-header">
                                <label for="externalQuoteDetails" class="section-title-label">Additional notes</label>
                            </div>
                            <textarea id="additionalInformation" class="text-area-additional-notes" maxlength="1000"
                                      v-model="additionalNotes"></textarea>
                        </fieldset>
                    </div>
                </div>
                <div class="spacing">
                    <b-button v-if="isExternalQuoteActive" class="custom-btn" @click="submitForm"
                              :disabled="disableSubmitButton" expanded>
                        Submit
                    </b-button>
                    <b-button v-if="isExternalQuoteActive" class="cannot-quote-button"
                              @click="cannotQuoteActive = true" type="button">
                        Cannot Quote
                    </b-button>
                </div>
            </div>
            <div v-if="currentStep === 'overview'">
                <div class="details-container">
                    <div class="left-side">
                        <fieldset class="fieldset-quote-details card">
                            <div class="overview-label-header">
                                <label for="externalQuoteDetails" class="section-title-label">Your Quote Details</label>
                            </div>
                            <div id="externalQuoteDetails" class="overview-details">
                                <ul>
                                    <li>
                                        Reference:
                                        <span v-if="externalQuote.reference !== null"
                                              class="detail">{{ externalQuote.reference }}</span>
                                        <span v-else class="detail">Not Available</span>
                                    </li>
                                    <li>
                                        Quotation State:
                                        <span v-if="externalQuote.state.state !== null"
                                              class="detail">{{ externalQuote.state.state | title }}</span>
                                        <span v-else class="detail">Not Available</span>
                                    </li>
                                    <li>
                                        Date: <span v-if="externalQuote.state.time !== null"
                                                    class="detail">{{ externalQuote.state.time | date }} </span>
                                        <span v-else class="detail">Not Available</span>
                                    </li>
                                </ul>
                            </div>
                        </fieldset>
                        <fieldset class="fieldset-overview-project card ">
                            <div class="overview-label-header">
                                <label for="projectDetails" class="section-title-label">Project</label>
                            </div>
                            <div id="projectDetails" class="overview-details">
                                <ul>
                                    <li>
                                        Project Reference: <span v-if="ref !== null" class="detail">{{ ref }}</span>
                                        <span v-else class="detail">Not Available</span>
                                    </li>
                                    <li>
                                        Project State: <span v-if="projectState.state !== null"
                                                             class="detail">{{ projectState.state | title }}</span>
                                        <span v-else class="detail">Not Available</span>
                                    </li>
                                    <li>
                                        State Change Date: <span v-if="projectState.time !== null"
                                                                 class="detail">{{ projectState.time | date }}</span>
                                        <span v-else class="detail">Not Available</span>
                                    </li>
                                </ul>
                            </div>
                        </fieldset>

                        <fieldset class="fieldset-Branch-Contact card">
                            <div class="overview-label-header">
                                <label for="externalQuoteDetails" class="section-title-label">Branch Contact</label>
                            </div>
                            <div class="branchContact">
                                <ul>
                                    <li>Name: <span class="detail-Branch-Contact">{{ branchContact.name }}</span></li>
                                    <li>Telephone: <span class="detail-Branch-Contact">{{
                                            branchContact.telephone
                                        }}</span>
                                    </li>
                                    <li>Email: <span class="detail-Branch-Contact"> {{ branchContact.email }} </span>
                                    </li>
                                </ul>
                            </div>
                        </fieldset>
                        <b-button v-if="isSupplierView" @click="reQuoteProject" class="reQuoteProjectButton" type="is-danger"
                                  :title="'Remove Uploaded Files'" v-tooltip expanded>
                            Re-Quote Project
                        </b-button>
                    </div>
                    <div class="right-side">
                        <div class="panel panel-primary panel-override">
                            <div class="overview-label-header">
                                <label for="externalQuoteDetails" class="section-title-label">Your Notes</label>
                            </div>
                            <div class="panel-body">
                                <div v-if="notes.length > 0" v-for="(note, index) in notes">
                                    <span class="section-title">{{ index + 1 }}) {{ note.note.plainText }}</span>
                                </div>
                                <div v-else class="section-title" style="text-align: center; margin-top: 2em">
                                    No notes have been added
                                </div>
                            </div>
                        </div>
                        <div class="panel panel-primary uploaded-quotes-overview card">
                            <div class="overview-label-header">
                                <label for="externalQuoteDetails" class="section-title-label">Uploaded Quotes</label>
                            </div>
                            <div v-if="state === 'READY' && externalQuote.files.length > 0"
                                 class="panel-body space-items">
                                <div v-for="(file, index) in quotesPrepared" class="col-md-3 file canDownload"
                                     :title="file.name">
                                    <div>
                                        <a target="_blank" :href="downloadLink(file, 'externalQuote')"
                                           @click="recordDownloadClick(file, 'externalQuote')">
                                            <fa class="fileType" :icon="file.icon"></fa>
                                            <fa icon="cloud-arrow-down"></fa>
                                            <p class="fileName">{{ file.name }}</p>
                                            <p class="download">Download</p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="section-title" style="text-align: center; margin-top: 2em">
                                No quotes have been uploaded for this project
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
